<div class="total-direct-content">
  <p
    class="text"
    *ngFor="let phase of totalDirectPerPhasesData?.totalDirectPerPhaseList"
    matTooltip="{{phase.phase}}"
    matTooltipPosition="above"
  >
    {{phase.numberOfDirectApplicants === 0 ? '-' : phase.numberOfDirectApplicants}}
  </p>
</div>
